import React, { useState } from 'react';
import { SpinnerFullPage } from 'shared/components/SpinnerFullPage/index.js';
import { Pages } from './pages';
import * as Sentry from "@sentry/react";

export function App() {
  const [initialized] = useState(true);

  const content = initialized
    ? (
      <div className='container mx-auto'>
        <Pages />
      </div>
    ) : (
      <SpinnerFullPage />
    );

  return (
    <Sentry.ErrorBoundary showDialog>
      {content}
    </Sentry.ErrorBoundary>
  );
}
